import React from 'react';
import About from './components/about/About';
import BgCanvas from './components/BgCanvas/BgCanvas';
import Contact from './components/contact/Contact';
import Experience from './components/experience/Experience';
import Footer from './components/footer/Footer';
import Hero from './components/Hero/Hero';
import Projects from './components/Projects/Projects';
import Skills from './components/Skills/Skills';
import TopNav from './components/TopNav/TopNav';
import { useReveal } from './hooks/useReveal';

const App = () => {
  useReveal();
  return (
    <>
      <BgCanvas />
      <TopNav />
      <Hero />
      <About />
      <Experience />
      <Projects />
      <Skills />
      <Contact />
      <Footer />
    </>
  );
};

export default App;
